// Teams / Workspaces feature flag (Roadmap #8).
//
// Mirrors the backend `TEAMS_ENABLED` Django setting + the app's REACT_APP_*
// convention: defaults OFF and is flipped per environment via a build var.
// When OFF the gated surface is byte-identical to today — no /teams route, no
// Settings "Team" tab, and the Teams data hooks are never mounted.
// Flip per environment with REACT_APP_TEAMS_ENABLED=true (staging sets "true").
const truthy = (v) => v === "true" || v === "1" || v === true;

export const TEAMS_ENABLED = truthy(process.env.REACT_APP_TEAMS_ENABLED);

export default TEAMS_ENABLED;
